<template>
  <div id="ModuleList" class="page message-list-page">
    <!-- 模块 -->
    <page-title page-name="模块" icon="iconfont icon-mokuai" @module-change="moduleChange" />
    <div v-if="platformCode" class="content-container">
      <div class="content-container">
        <div class="search-line">
          <el-form class="search-form" inline :model="searchForm" @submit.native.prevent>
            <!-- 适配软件 -->
            <software-select
                ref="softwareSelect"
                :resource-type="resourceType"
                :sub-module="currentSubmodule"
                :platform="platformCode"
                :is-version-require="false"
                :is-available="availableResource"
                @change="changeSoftware"
            />
            <!-- 状态 -->
            <el-form-item label="状态">
              <el-select class="status-select" v-model="searchForm.status" placeholder="不限" :disabled="availableResource" clearable @change="()=>search()" style="width: 100px;">
                <el-option
                    v-for="item in statusOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="模块类型">
              <el-select class="module-type-select" v-model="searchForm.module_type" placeholder="不限" :disabled="availableResource" clearable @change="(opts)=>changeModuleType(opts)">
                <el-option
                    v-for="item in moduleTypeOpts"
                    :key="item.value"
                    :label="item.displayValue"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="showModuleFunctionType" label="功能类型">
              <el-select class="module-function-type-select" v-model="searchForm.module_function_type" :disabled="availableResource" placeholder="不限" clearable @change="()=>search()">
                <el-option
                    v-for="item in functionTypeOpts"
                    :key="item.value"
                    :label="item.displayValue"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
            <!-- 只看可用资源 -->
            <el-form-item v-if="clientType !== 'web' && clientTypeSoftwareCode === softwareCode">
              <el-switch
                  v-model="availableResource"
                  class="available-switch"
                  active-color="009EE1"
                  inactive-color="BFBFBF"
                  active-text="只看可用资源"
                  @change="changeAvailableResource">
              </el-switch>
            </el-form-item>
          </el-form>
          <div>
            <el-input
                v-model="searchForm.keyword"
                class="keyword-input"
                clearable
                placeholder="搜索名称"
                @change="()=>search()"
            >
              <i slot="append" class="el-icon-search" />
            </el-input>
          </div>
        </div>
        <div class="flex-1">
          <gjw-list-page-layout>
            <template #leftBox>
              <div class="catalog">
                <ClassifyTreeV2
                    ref="classifyTree"
                    :tree-data="classifyData.tree"
                    :list-data.sync="classifyData.list"
                    :draggable="true"
                    :editable="true"
                    :expanded-keys="defaultKeyArr"
                    :currentSubmodule="currentSubmodule"
                    @updateListData="updateListData"
                    @tree-node-click="treeNodeClick"
                    @node-expand="treeNodeExpand"
                    @node-collapse="treeNodeCollapse"
                    @handleDrop="handleDrop"
                    @handleRename="handleRename"
                    @handleNew="handleNew"
                    @stopPolling="stopPolling"
                    @startPolling="startPolling(polling)"
                />
              </div>
            </template>
            <!-- 批量操作 -->
            <template #btnBox>
              <div class="btn-left">
                <div class="operations-left">
                  <el-button type="primary" icon="iconfont icon-wenjian-shangchuan" :disabled="hasPermission(activePermissionType, 'NOVA_DESIGN_MODULE_UPLOAD')" @click="showUploader('upload')">上传</el-button>
                </div>
                <div v-if="selectedList.length" class="batch-button-box">
                  <el-button v-if="clientType === 'web'" icon="iconfont icon-wenjian-xiazai" plain @click="batchModuleDownload">下载</el-button>
                  <el-button icon="iconfont icon-yidong" plain @click="openClassifyDialog">移动</el-button>
                  <el-button icon="iconfont icon-wenjian-shanchu" class="delete-button" plain @click="batchDelete('deleteSpaceScheme')">删除</el-button>
                </div>
                <div v-else class="batch-button-box">
                  <el-tooltip v-if="clientType === 'web'" content="请先勾选操作对象" placement="bottom">
                    <span class="disabled-button"><i class="iconfont icon-wenjian-xiazai" /><span>下载</span></span>
                  </el-tooltip>
                  <el-tooltip content="请先勾选操作对象" placement="bottom">
                    <span class="disabled-button"><i class="iconfont icon-yidong" /><span>移动</span></span>
                  </el-tooltip>
                  <el-tooltip content="请先勾选操作对象" placement="bottom">
                    <span class="disabled-button"><i class="iconfont icon-wenjian-shanchu" /><span>删除</span></span>
                  </el-tooltip>
                </div>
              </div>
              <div class="btn-right">
                <span>共 {{ dataTotal }} 个内容</span>
                <el-button
                    type="text"
                    icon="el-icon-refresh-right"
                    title="刷新"
                    class="refresh-btn"
                    @click="getList(true, true)"
                />
              </div>
            </template>
            <template #tableBox>
              <gjw-table
                  ref="listTable"
                  v-loading="tableLoading"
                  :columns="tableColumns"
                  :list-data="tableData"
                  :has-page="false"
                  :sort-map="sortMap"
                  @table-selection-change="selectionChange"
                  @table-sort-change="sortChange"
                  @row-dblclick="rowDblclick"
              >
                <template #imageSlot="{ row }">
                  <img v-if="row.status !== 'PROCESSING' && row.thumbnail" :src="$hosts.static(row.thumbnail)" class="thumbnail" @error="handleThumbnailError" />
                  <img v-else src="@/assets/img/resource-default.png" class="thumbnail" />
                </template>
                <template #nameLabelSlot>
                  <span>名称</span>
                </template>
                <template #nameSlot="{ row, index }">
                  <edit-input
                      v-if="modifyIndex === index && modifyCol === 'name'"
                      ref="editName"
                      :maxlength="30"
                      :init-value="tempRow.name"
                      @edit-confirm="(value)=>modifyName(row, value)"
                      @edit-cancel="resetModify"
                  />
                  <span v-else>
                  {{ row.name }}
                </span>
                </template>
                <template #categorySlot="{ row }">
                  {{ row.spaceCategoryNames && row.spaceCategoryNames.length ? row.spaceCategoryNames.join('>') : '' }}
                </template>
                <template #statusLabelSlot>
                  <span>状态</span>
                </template>
                <template #statusSlot="{ row }">
                  <span v-if="row.status === 'PROCESSING'" class="ft-grey grey statusButton">解析中</span>
                  <span v-if="row.status === 'TOBE_RELEASED'" class="ft-green green statusButton">解析成功</span>
                  <span v-if="row.status === 'PROCESSED_FAILED'" class="ft-red red statusButton">解析失败</span>
                </template>
                <template #operateSlot="{ row , index}">
                  <template>
                    <el-button
                        type="text"
                        title="载入"
                        v-if="clientType === 'g' && clientTypeSoftwareCode === row.softwareCode"
                        :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_LOAD') || clientTypeSoftwareVersion < row.softwareVersion"
                        @click="toLoad(row)"
                    >
                      <span>载入</span>
                    </el-button>
                    <el-button
                        type="text"
                        title="详情"
                        :disabled="row.status ==='PROCESSING' || hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_DETAIL')"
                        @click="toDetail(row)"
                    >
                      <span>详情</span>
                    </el-button>
                    <el-button
                        type="text"
                        title="更新"
                        :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_UPDATE')"
                        @click="onRenewal(row, 'renewal')"
                        v-if="clientType === 'web'"
                    >
                      <span>更新</span>
                    </el-button>
                    <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-if="clientType !== 'web'"
                            :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_UPDATE')"
                            @click.native="onRenewal(row,'renewal')">更新</el-dropdown-item>
                        <el-dropdown-item :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_RENAME')" @click.native="cellClick(row,index, 'name')">重命名</el-dropdown-item>
                        <el-dropdown-item :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_MOVE')" @click.native="openClassifyDialog(row)">移动</el-dropdown-item>
                        <el-dropdown-item :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_DOWNLOAD')" v-if="clientType === 'web'" @click.native="toDownload(row)">下载</el-dropdown-item>
                        <el-dropdown-item :disabled="hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_DELETE')" :class="!hasPermission(row.permissionType, 'NOVA_DESIGN_MODULE_DELETE') && 'delete'" @click.native="deleteResources(row)">删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </template>
              </gjw-table>
            </template>
            <template #footerBox>
              <uploader
                  ref="uploader"
                  class="component-uploader"
                  :resource-type="resourceType"
                  :operate='operateType'
                  :allow-types="allowFileType(softwareCode)"
                  :platform="platformCode"
                  :software-code="softwareCode"
                  :software-version="softwareVersion"
                  :language="language"
                  :file-table-columns="uploaderFileTableColumns"
                  :space-category-id="spaceCategoryId || spaceCategoryId === 0 ? spaceCategoryId : rootNode.id"
                  :space-classify-tree="spaceClassifyTree"
                  :renewal-obj="renewalObj"
                  @success="uploadCallback" />
              <el-pagination
                  class="pagination"
                  layout="prev, pager, next, sizes"
                  :pager-count="5"
                  :total="dataTotal"
                  :current-page="pageNo"
                  :page-size="pageSize"
                  :page-sizes="[10, 20, 50, 100]"
                  @current-change="currentChange"
                  @size-change="sizeChange" />
            </template>
          </gjw-list-page-layout>
        </div>
      </div>
      <!--移动-->
      <gjw-dialog
          :show-dialog="showClassifyDialog"
          class="ClassifyDialog"
          :title="typeName"
          :confirm-loading="moveLoading"
          @close="closeClassifyDialog"
          @confirm="() => { confirmModifyClassify(batchClassifyValue); }">
        <classifySelectV2
            ref="classifySelectDialog"
            :tree-data="classifyData.tree"
            :expanded-keys="[rootNode.id]"
            @tree-node-click="chooseBatchClassify"
        />
      </gjw-dialog>
      <module-detail-plugin ref="pluginModuleDetailDrawer" :current-submodule="currentSubmodule" @close="handleClose" @toLoad="toLoad" />
      <!-- 载入 -->
      <load-progress-bar-dialog v-if="clientType !== 'web'" ref="LoadProgressBarDialogRef" :resource-type="resourceType" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Dict from '@/core/dict'
import Utils from '@/core/utils'
import { RegSymbol } from '@/core/RegExp'
import PageTitle from '@/components/business/PageTitle.vue'
import EditInput from '@/components/business/EditInput.vue'
import SoftwareSelect from '@/components/business/resource/SoftwareSelect.vue'
import classifySelectV2 from '@/components/business/resource/classifySelectV2.vue'
import ClassifyTreeV2 from '@/components/business/resource/ClassifyTreeV2.vue'
import Uploader from '@/components/business/resource/Uploader.vue'
import Queue from '@/core/queue'
import { getFileTypes, getSoftwareCodesByPlatformCode } from '@/assets/js/resourceMap.js'
import resourceOperations from '@/mixins/resourceOperations'
import permissionMixin from '@/mixins/permissionMixin.js'
import ModuleDetailPlugin from './ModuleDetailPlugin.vue'
import LoadProgressBarDialog from '../components/LoadProgressBarDialog.vue'
import resourceDefault from '@/assets/img/resource-default.png'
import pollingMixin from '@/mixins/pollingMixin'

export default {
  name: 'ModuleList',
  components: {
    PageTitle,
    SoftwareSelect,
    ClassifyTreeV2,
    EditInput,
    Uploader,
    classifySelectV2,
    ModuleDetailPlugin,
    // SelectComponentType,
    LoadProgressBarDialog
  },
  mixins: [resourceOperations, permissionMixin, pollingMixin],
  data() {
    return {
      // 是否为首次进入页面
      firstEnter: true,
      // 构件的资源类型
      resourceType: 'MODULE',
      language: null,
      currentSubmodule: '',
      platformCode: '',
      softwareCode: '',
      softwareVersion: '',
      searchForm: {},
      activeClassifyTab: 'space',
      statusOpts: Dict.statusOptionsAll,
      functionTypeOpts: [],
      moduleTypeOpts: [],
      showModuleFunctionType: false,
      tableData: [],
      tableLoading: false,
      sortMap: { createTime: 'CREATE_TIME', updateTime: 'UPDATE_TIME' },
      modifyIndex: -1, // 当前要修改的行序
      modifyCol: '', // 当前要修改的col
      tempRow: {}, // 备份要修改的row
      showClassifyDialog: false,
      batchClassifyValueDisable: true, // 修改分类弹窗的确定按钮是否可点击
      batchClassifyValue: false,
      dataTotal: 0,
      pageNo: 1,
      pageSize: 20,
      operateType: 'upload',
      renewalObj: {},
      crQueue: new Queue(5, this.createNewModule), // 创建队列实例
      reQueue: new Queue(5, this.renewalModule), // 更新队列实例
      spaceId: this.$route.params.spaceId,
      spaceResourceId: '',
      spaceCategoryIdMove: '',
      typeName: '移动到',
      moveLoading: false,
      availableResource: false,
      activePermissionType: '',
      defaultKeyArr: []
    }
  },
  computed: {
    ...mapGetters({
      spacesDetail: 'classifySpace/spacesDetail',
      spacePlatClassify: 'classifySpace/spacePlatClassify',
      spaceClassifyTree: 'classifySpace/spaceClassifyTree',
      getSpaceTreeAuthWithCount: 'classifySpace/getTreeAuthWithCount',
      getSpaceRootNode: 'classifySpace/getRoot',
      clientTypeSoftwareCode: 'softwareCode',
      clientTypeSoftwareVersion: 'softwareVersion',
      clientType: 'platform',
    }),
    tableColumns() {
      const allCols = [
        {
          type: 'selection',
          width: '48px',
          attrs: {
            align: 'center',
          },
        },
        {
          type: 'slot',
          slotName: 'imageSlot',
          label: '缩略图',
          prop: 'thumbnail',
          width: '60px',
          fmtUrl: (url) => this.$hosts.static(url),
        },
        {
          type: 'slot',
          slotName: 'nameSlot',
          labelSlotName: 'nameLabelSlot',
          prop: 'name',
          minWidth: '100px',
        },
        {
          type: 'slot',
          slotName: 'categorySlot',
          label: '所属目录',
          prop: 'spaceCategoryNames',
          minWidth: '160px',
        },
        {
          label: '适配版本',
          prop: 'softwareVersionName',
          minWidth: '80px',
        },
        {
          label: '创建时间',
          prop: 'createTime',
          sortable: false,
          minWidth: '118px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          label: '更新时间',
          prop: 'updateTime',
          sortable: false,
          minWidth: '118px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          type: 'slot',
          slotName: 'statusSlot',
          minWidth: '90px',
          labelSlotName: 'statusLabelSlot',
          prop: 'status'
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          minWidth: '120px'
        },
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    },
    uploaderFileTableColumns() {
      return {
        appName: this.platformCode === 'NOVA_DESIGN',
        classify: this.operateType !== 'renewal',
        validation: this.platformCode === 'NOVA_DESIGN',
      }
    },
    uploaderSpaceClassifyId() {
      const spaceCategoryId = this.spaceCategoryId
      return spaceCategoryId || spaceCategoryId === 0 ? spaceCategoryId : this.rootNode.id
    },
    rootNode() {
      return this.getSpaceRootNode
    },
    classifyData() {
      return this.getSpaceTreeAuthWithCount
    },
  },
  created() {
    this.startPolling(this.polling)
  },
  mounted() {
    if (!this.spaceId) { return }
    const query = {
      resource_type: this.resourceType,
      space_id: this.spaceId,
      platform_code: this.platformCode,
    }
    this.getSpacePlatClassify(query)
  },
  methods: {
    ...mapActions({
      // 获取当前用户有权限的目录列表
      getSpacePlatClassify: 'classifySpace/getSpacePlatClassify',
      getSpacePlatClassifyAgg: 'classifySpace/getSpacePlatClassifyAgg',
      getSpacesDetail: 'classifySpace/getSpacesDetail',
    }),
    handleThumbnailError(event) {
      event.target.src = resourceDefault
    },
    isAvailableROperation(item) {
      return this.platform === 'r' && item.status === ''
    },
    isAvailableGOperation() {
      return this.platform === 'web'
    },
    // 获取模块类型选项
    getModuleTypeOptions() {
      const query = {
        resource_type: this.resourceType,
        software_code: this.softwareCode,
        property_code: 'MODULE_TYPE'
      }
      this.$api.resource.getPropertyValues(this.spaceId, query).then((data) => {
        this.moduleTypeOpts = data || []
      }).catch(() => {
        this.moduleTypeOpts = []
      })
    },
    // 获取功能类型选项
    getFunctionTypeOptions() {
      const query = {
        resource_type: this.resourceType,
        software_code: this.softwareCode,
        property_code: 'MODULE_FUNCTION_TYPE'
      }
      this.$api.resource.getPropertyValues(this.spaceId, query).then((data) => {
        this.functionTypeOpts = data || []
      }).catch(() => {
        this.functionTypeOpts = []
      })
    },
    moduleChange(subModuleCode) {
      this.currentSubmodule = subModuleCode
      this.platformCode = Utils.splitPlatform(subModuleCode)
      this.softwareCode = getSoftwareCodesByPlatformCode(this.platformCode)
      this.$refs.softwareSelect && this.$refs.softwareSelect.resetSelectedVersion()
      this.resetSelectedClassify()
      this.selectedList = []
      // 切换资源类型后，适配软件一定会切换，所以此处不需要调用search()，但需要清空searchForm。
      this.searchForm = {}
      this.firstEnter = true
    },
    changeSoftware({ software, version, changeType }) {
      this.softwareCode = software.softwareCode
      this.softwareVersion = version.softwareVersion
      if (this.firstEnter) {
        this.availableResource = this.clientType !== 'web' && this.clientTypeSoftwareCode === this.softwareCode
      } else {
        this.availableResource = false
      }
      if (changeType === 'software') {
        this.getModuleTypeOptions()
        this.getFunctionTypeOptions()
      }
      this.search(true, !this.firstEnter)
      this.firstEnter = false
    },
    async filterClassify(query) {
      try {
        const query = {
          ...this.searchForm,
          resource_type: this.resourceType,
          space_id: this.spaceId,
          software_code: this.availableResource ? this.clientTypeSoftwareCode : this.softwareCode,
          software_version: this.availableResource ? null : this.softwareVersion,
          software_platform: this.platformCode,
          native_software_version: this.availableResource ? this.clientTypeSoftwareVersion : null,
          available_resources: this.availableResource || null
        }
        if (this.availableResource) {
          query.status = null
        }
        await this.getSpacePlatClassifyAgg(query)
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },
    treeNodeClick(node) {
      this.activePermissionType = node.permissionType
      this.resetSelectedClassify()
      this.spaceCategoryId = node.id
      !this.defaultKeyArr.includes(node.id) && this.defaultKeyArr.push(node.id)
      this.$refs.classifyTree?.highlightSomeNode(this.spaceCategoryId)
      this.search(false)
    },
    treeNodeExpand(node) {
      this.treeNodeClick(node)
    },
    treeNodeCollapse(node) {
      if (this.defaultKeyArr.includes(node.id)) {
        this.defaultKeyArr = this.defaultKeyArr.filter((item) => item !== node.id)
      }
    },
    // 打开弹框
    async openClassifyDialog(row) {
      if (row && row.spaceResourceId) {
        await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
        if (row.name) {
          this.typeName = '移动 ' + row.name + ' 到'
          // 获取当前选中ID
          this.spaceResourceId = row.spaceResourceId
        } else {
          this.typeName = '移动到'
        }
      }
      this.showClassifyDialog = true
    },
    // 关闭弹框
    closeClassifyDialog() {
      this.showClassifyDialog = false
      this.batchClassifyValue = ''
      this.moveLoading = false
    },
    // 目标节点选取
    chooseBatchClassify(value) {
      this.spaceCategoryIdMove = value.id
      this.batchClassifyValue = value.id
      this.batchClassifyValueDisable = false
    },
    // 移动
    confirmModifyClassify() {
      this.moveLoading = true
      // 批量移动
      if (this.typeName === '移动到') {
        this.batchUpdateClassify(this.batchClassifyValue, 'moveSpaceModule')
      } else {
        const params = {
          spaceResourceId: this.spaceResourceId,
          spaceCategoryId: this.spaceCategoryIdMove,
        }
        this.$api.resource
          .spaceCategory(this.spaceId, params)
          .then(() => {
            this.$message.success(`移动成功`)
            this.$tracks({
              event: 'moveSpaceModule',
              params: { g_c_space_id: this.spaceId, }
            })
            this.search(true, false)
            this.closeClassifyDialog()
          })
          .catch((err) => {
            this.moveLoading = false
            if (err.code === 'space.resource.name.duplicate') {
              this.$message.error('目标文件夹下存在重名资源')
            } else if (err.code === 'space.resource.update.category.empty.error') {
              this.$message.error('移动失败')
            }
          })
      }
    },
    // 删除
    async deleteResources(row) {
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      this.$confirm(`是否确定删除 <b>${row.name}.${row.suffix}</b>？`, {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonClass: 'user-confirm',
        confirmButtonText: '确定删除',
      })
        .then(() => {
          this.$api.resource
            .deleteSpaceResources(this.spaceId, row.id)
            .then((res) => {
              if (res === true) {
                this.$message.success(`删除成功`)
                this.$tracks({
                  event: 'deleteSpaceModule',
                  params: { g_c_space_id: this.spaceId, }
                })
                this.search(true, false)
              }
            })
            .catch((err) => {
              const errors = {
                'resource.exist': '请将节点下的内容移除后再试。',
                'space.resource.delete.error': '删除失败',
              }
              this.$matchError(err.code, errors, '删除失败')
            })
        })
        .catch(() => {})
    },
    // 下载
    toDownload(item) {
      if (item.downloadLoading) {
        return false
      }
      // 资源下载，弹框评分
      this.checkFeedbackExists()
      this.$api.resource.getDownloadUrl(this.spaceId, item.spaceResourceId, item.id, item.dataVersionId)
        .then((res) => {
          this.$downloadFile(res)
          this.$tracks({
            event: 'downloadSpaceModule',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: item.spaceResourceId,
            }
          })
        }).finally((e) => {
          item.downloadLoading = false
        })
    },
    updateListData(value) {
      if (value === 'permission') {
        this.$tracks({ event: 'modifyModuleFolderPermission', params: { g_c_space_id: this.spaceId }})
      } else if (value === 'deleteNode') {
        this.$tracks({ event: 'deleteModuleFolder', params: { g_c_space_id: this.spaceId }})
      }
      this.search(true, false)
    },
    handleDrop() {
      this.search(true, false)
    },
    handleRename() {
      this.$tracks({ event: 'renameModuleFolder', params: { g_c_space_id: this.spaceId }})
      this.search(true, false)
    },
    handleNew() {
      this.$tracks({ event: 'newModuleFolder', params: { g_c_space_id: this.spaceId }})
      this.search(true, false)
    },
    resetSelectedClassify() {
      this.softwareCategoryCode = null
      this.spaceCategoryId = null
    },
    sortChange(sortObj) {
      this.searchOrder = { ...sortObj }
      this.search()
    },
    rowDblclick(row) {
      this.toDetail(row)
    },
    async changeAvailableResource() {
      await this.search()
    },
    changeModuleType(opts = '') {
      const moduleFunctionType = opts !== '' && opts !== '详图模块'
      this.showModuleFunctionType = moduleFunctionType
      if (!moduleFunctionType) {
        this.searchForm.module_function_type = null
      }
      this.search()
    },
    async search(refreshClassify = true, isTrack = true) {
      this.pageNo = 1
      await this.getList(refreshClassify, isTrack)
    },
    async getList(refreshClassify = true, isTrack = false) {
      // 更新数据时，取消编辑状态
      this.resetModify()
      const query = {
        ...this.searchForm,
        page_no: this.pageNo,
        page_size: this.pageSize,
        space_id: this.spaceId,
        resource_type: this.resourceType,
        software_platform: this.platformCode,
        software_code: this.availableResource ? this.clientTypeSoftwareCode : this.softwareCode,
        software_version: this.availableResource ? null : this.softwareVersion,
        space_category_id: this.spaceCategoryId,
        native_software_version: this.availableResource ? this.clientTypeSoftwareVersion : null,
        available_resources: this.availableResource || null
      }
      if (this.availableResource) {
        query.status = null
      }
      this.tableLoading = true
      if (refreshClassify) {
        const query = {
          resource_type: this.resourceType,
          space_id: this.spaceId,
          platform_code: this.platformCode,
        }
        await this.getSpacePlatClassify(query).catch()
        this.filterClassify({ ...query }).then(() => {
          // 选中节点高亮并展开
          const id = this.spaceCategoryId
          const key = id || id === 0 ? id : this.rootNode.id
          this.$nextTick(() => {
            this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(key)
            !this.defaultKeyArr.includes(this.classifyData.tree[0]?.id) && this.defaultKeyArr.push(this.classifyData.tree[0]?.id)
            this.activePermissionType = this.classifyData.tree[0].permissionType
          })
        })
      }
      this.$api.resource
        .getSpaceResources(this.spaceId, query)
        .then((data) => {
          this.tableData = data.list || []
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            item.permissionType = (this.spacePlatClassify.find((f) => f.id === item.spaceCategoryId) || {}).permissionType
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
          if (isTrack) {
            this.$tracks({
              event: 'querySpaceModule',
              params: {
                g_c_space_id: this.spaceId,
                g_c_keyword: query.keyword,
                g_c_folder_id: query.space_category_id,
                g_c_condition: query,
                g_c_result_count: data.totalCount
              }
            })
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    // 轮询获取列表
    async getListForPolling() {
      const query = {
        ...this.searchForm,
        page_no: this.pageNo,
        page_size: this.pageSize,
        space_id: this.spaceId,
        resource_type: this.resourceType,
        software_platform: this.platformCode,
        software_code: this.availableResource ? this.clientTypeSoftwareCode : this.softwareCode,
        software_version: this.availableResource ? null : this.softwareVersion,
        space_category_id: this.spaceCategoryId,
        native_software_version: this.availableResource ? this.clientTypeSoftwareVersion : null,
        available_resources: this.availableResource || null
      }
      if (this.availableResource) {
        query.status = null
      }
      const queryClassify = {
        resource_type: this.resourceType,
        space_id: this.spaceId,
        platform_code: this.platformCode,
      }
      this.filterClassify({ ...queryClassify }).then(() => {
        // 选中节点高亮
        const id = this.spaceCategoryId
        const key = id || id === 0 ? id : this.rootNode.id
        this.$nextTick(() => {
          this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(key)
          this.activePermissionType = this.classifyData.tree[0].permissionType
        })
      })

      this.$api.resource
        .getSpaceResources(this.spaceId, query)
        .then((data) => {
          this.tableData = data.list || []
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            item.permissionType = (this.spacePlatClassify.find((f) => f.id === item.spaceCategoryId) || {}).permissionType
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
        })
    },
    // 判断行数据是否可单个编辑
    canEdit(row) {
      return true
    },
    // 修改之后重置
    resetModify() {
      this.startPolling(this.polling)
      this.modifyCol = ''
      this.modifyIndex = -1
      this.tempRow = {}
    },
    // 修改名称
    async modifyName(row, value) {
      if (row.name === value) {
        this.resetModify()
        return
      }
      if (RegSymbol.test(value)) {
        this.$message.error('名称中有禁止的特殊符号')
        return
      }
      await this.$api.resource.updateName(this.spaceId, row.spaceResourceId, { name: value }).then((res) => {
        this.$message.success(`修改成功`)
        this.$tracks({
          event: 'renameSpaceModule',
          params: { g_c_space_id: this.spaceId, }
        })
        this.resetModify()
        this.getList()
      }).catch((err) => {
        const errors = {
          'resource.not.exist': '资源不存在',
          'resource.name.contain.special.characters': '名称中有禁止的特殊符号',
          'resource.name.already.existed': '资源名称已存在',
          'name.length.exceed': '资源名称查出限制',
        }
        this.$matchError(err.code, errors, '修改失败')
      })
    },
    // 点击构件名称 单元格时触发
    async cellClick(row, index, colName) {
      this.stopPolling()
      if (!this.canEdit(row)) {
        return
      }
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      this.modifyCol = colName
      this.modifyIndex = index
      this.tempRow = { ...row }
      this.$nextTick(() => {
        switch (colName) {
          case 'name':
            this.$refs.editName.toFocus()
            break
        }
      })
    },
    // 点击上传
    async showUploader(operateType) {
      // 资源上传，弹框评分
      this.checkFeedbackExists().catch()
      await this.$api.resource.hasResources(this.spaceId, this.spaceCategoryId)
      this.operateType = operateType
      this.$refs.uploader.showModal(operateType)
    },
    async batchModuleDownload() {
      // 资源批量下载，弹框评分
      this.checkFeedbackExists().catch()
      const operationKey = await this.getOperationKey(null, 'id')
      this.$api.resource.batchDownload(this.spaceId, operationKey).then((res) => {
        if (res.length > 0) {
          res.forEach((v) => {
            this.$downloadMultipleFile(v.downloadUrl, v.name)
          })
          this.$tracks({
            event: 'downloadSpaceModule',
            params: {
              g_c_space_id: this.spaceId,
              g_c_batch: true,
              g_c_count: res.length
            }
          })
        }
      }).finally((e) => {
        this.$fullLoading.close()
      })
    },
    batchToLoad() {
      // 资源批量载入，弹框评分
      this.checkFeedbackExists().catch()
      this.selectedList.forEach((item) => {
        this.toLoad(item)
      })
    },
    async onRenewal(row, operateType) {
      // 资源更新，弹框评分
      this.checkFeedbackExists().catch()
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      this.operateType = operateType
      this.renewalObj = row
      this.renewalObj.spaceId = this.spaceId
      this.$refs.uploader.showModal(operateType)
    },
    allowFileType(softwareCode) {
      if (softwareCode) {
        const types = getFileTypes('MODULE', softwareCode) || []
        return types.join(',')
      }
    },
    // 秒传/上传后的回调
    uploadCallback({ file, id }) {
      this.$refs.uploader.updateFile(file, { uploadProgress: 100 })
      if (file.operate === 'upload') {
        this.crQueue.preDo({ file, id })
      } else {
        // 替换
        this.reQueue.preDo({ file, id })
      }
    },
    // 创建新模块
    createNewModule({ file, id }) {
      const params = {
        md5: file.md5,
        name: file.name,
        language: file.language,
        originalSoftwareVersion: file.appVersion, // 资源解析出来的或者没有
        resourceType: 'MODULE',
        softwareCategoryCode: file.categoryCode, // 解析到软件分类编码
        softwareCode: file.softwareCode,
        spaceCategoryId: file.spaceCategoryId,
        storeId: id,
        tagIds: file.tagIds,
        targetSoftwareVersion: null, // 需要升级的资源是当前选中的软件版本，其余设置为空
      }
      this.$api.resource.createResource(this.spaceId, params).then((res) => {
        // 根据接口返回增加一种字段 更新成功 updateSuccess
        if (res && res.creationPolicy === 'NEW') {
          this.$tracks({
            event: 'uploadSpaceModule',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: res.id,
              g_c_file_format: res.suffix
            }
          })
          const uploadStatus = 'success'
          this.$refs.uploader.updateFile(file, { uploadStatus, uploadProgress: 100 })
          this.$refs.softwareSelect && this.$refs.softwareSelect.softwareChange()
        } else {
          let uploadStatus = 'fail'
          if (['resource.name.already.existed', 'resource.md5.already.existed'].includes(res.code)) {
            uploadStatus = 'existed'
          }
          this.$refs.uploader.updateFile(file, { uploadStatus: uploadStatus })
        }
      }).catch((err) => {
        let uploadStatus = 'fail'
        if (['resource.name.already.existed', 'resource.md5.already.existed'].includes(err.code)) {
          uploadStatus = 'existed'
        }
        this.$refs.uploader.updateFile(file, { uploadStatus: uploadStatus })
      }).finally(() => {
        this.crQueue.nextDo()
      })
    },
    // 更新资源
    renewalModule({ file, id }) {
      const params = {
        softwareCode: file.softwareCode,
        softwareVersion: file.softwareVersion,
        language: file.language,
        name: file.name,
        md5: file.md5,
        resourceType: 'MODULE',
        storeId: id,
      }
      this.$api.resource.renewalResource(this.spaceId, file.spaceResourceId, file.softwareVersionId, params).then((res) => {
        if (res === true) {
          this.$tracks({
            event: 'updateSpaceModule',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: file.spaceResourceId,
            }
          })
          this.$refs.uploader.updateFile(file, { uploadStatus: 'success', uploadProgress: 100 })
          this.search(true, false)
        }
      }).catch((err) => {
        if (err.code === 'resource.exist') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'md5Duplicate' })
        } else if (err.code === 'resource.mismatch') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'versionMismatch' })
        } else if (err.code === 'space.resource.software.version.not.exist') {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'notExisted' })
        } else {
          this.$refs.uploader.updateFile(file, { uploadStatus: 'fail' })
        }
      }).finally(() => {
        this.reQueue.nextDo()
      })
    },
    async toDetail(row) {
      // 资源详情，弹框评分
      this.checkFeedbackExists().catch()
      // 先判断资源是否存在
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      const detail = this.$router.resolve({
        name: 'ModuleDetail',
        params: { spaceId: this.spaceId, resourceId: row.spaceResourceId },
        query: {
          softwareCode: row.softwareCode,
          softwareVersion: row.softwareVersion,
          currentSubmodule: this.currentSubmodule
        },
      })
      if (this.clientType === 'web') {
        window.open(`${detail.href}&title=${row.name}`, '_blank')
      } else {
        this.$refs.pluginModuleDetailDrawer &&
        this.$refs.pluginModuleDetailDrawer.openDrawer(this.spaceId, row)
      }
    },
    handleClose() {
      this.search(true, false)
    },
    async toLoad(row, subdivideType = 'single') {
      // 资源载入，弹框评分
      this.checkFeedbackExists().catch()
      await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      this.$refs.LoadProgressBarDialogRef?.openDialog(this.spaceId, row, subdivideType)
    },
    // async toPlace(row) {
    //   await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
    //   this.$refs.pluginPlaceTypeDialog && this.$refs.pluginPlaceTypeDialog.openDialog(this.spaceId, row)
    // },
    // 分页
    currentChange(val) {
      this.pageNo = val
      this.getList(false)
    },
    sizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getList(false)
    },
    async polling() {
      await this.getListForPolling()
    },
  },
}
</script>

<style lang="less" scoped>
.flex-1 {
  height: calc(100vh - 136px);
}

.search-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 16px;
}

.batch-button-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

/deep/.el-table__header {
  background-color: grey;
}

/deep/.el-dropdown {
  color: #009ee1;
}

.delete {
  color: red;
}

.delete:hover {
  color: #fff;
  background: red;
}

.el-dropdown-menu {
  width: 70px;
  // height: 112px;
  border-radius: 2px;
  padding: 4px 0px;
  text-align: center;
}

.statusButton {
  padding: 1px 5px;
  border-radius: 2px;
}

.green {
  background: #fafafa;
  border: 1px solid #b7eb8f;
}

.grey {
  background: @bg-grey-light-2;
  border: 1px solid @border-color-tag;
}

.red {
  background: #fff1f0;
  border: 1px solid #ffa39e;
}

.el-tree {
  margin-left: 2px;
}

.btn-left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  /deep/ .el-button-group {
    line-height: unset;
  }

  .el-button {
    margin-right: 4px;
  }

  .operations-left {
    margin-right: 12px;
  }

  .el-dropdown-link {
    display: inline-block;
    padding: 0 15px;
    font-size: 12px;
    font-weight: 500;
    height: 30px;
    line-height: 30px;
    border: 1px solid @border-color;
    border-radius: 0 4px 4px 0;
  }
}

.keyword-input {
  width: 200px;
}

.btn-right {
  color: rgba(73, 95, 112, 0.6);
  font-size: 12px;
}

.component-uploader {
  position: fixed;
  bottom: 0;
  z-index: 999;
}

.thumbnail {
  width: 40px;
  height: 40px;
}

.catalog {
  max-height: calc(100vh - 138px);
}

.delete-button:hover,
.delete-button:focus,
.delete-button:active {
  background: #fff;
  border-color: red;
  color: red;
}
/deep/ .right-part {
  width: 1px;
  height: calc(100vh - 145px);
}

/deep/ .el-table .el-table__body-wrapper {
  max-height: calc(100% - 41px);
}
</style>
<style>
.el-switch .el-switch__label{
  font-weight: normal;
  color:#495F70
}
.el-switch__label.is-active{
  color:#495F70
}
.el-message-box .el-message-box__btns .user-confirm {
  color: #ff4d4f;
  width: 88px;
  height: 32px;
  border: 1px solid #ff4d4f;
  border-radius: 2px;
  background: #ffffff;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.016);
}
.available-switch .el-switch__label * {
  font-size: 12px;
}
.module-type-select .el-input,
.module-function-type-select .el-input {
  font-size: 12px;
}
</style>
